import { render, staticRenderFns } from "./BoardDetailLink.vue?vue&type=template&id=66c02eff&scoped=true"
import script from "./BoardDetailLink.vue?vue&type=script&lang=js"
export * from "./BoardDetailLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c02eff",
  null
  
)

export default component.exports